<mat-toolbar>

    <div class="fx-row fx-justify-center fx-items-center fx-flex fx-gt-xs-justify-space-between fx-gt-xs-items-center">

        <a href="https://1.envato.market/c/1257954/275988/4415?u=https%3A%2F%2Fthemeforest.net%2Fitem%2Ffuse-angularjs-material-design-admin-template%2F12931855" target="_blank" mat-button class="pink fx-flex-0-0-auto fx-row fx-justify-start fx-items-center">
            <mat-icon class="s-16 mr-sm-4">shopping_cart</mat-icon>
            <span>Purchase FUSE (Angular 7+)</span>
        </a>

        <div class="fx-row fx-justify-start fx-items-center fx-hide fx-show-gt-xs">
            <a mat-button routerLink="/documentation/getting-started/introduction">Documentation</a>
            <span>&bull;</span>
            <a mat-button routerLink="/documentation/changelog">Changelog</a>
        </div>

    </div>

</mat-toolbar>
